/**
 * created by lei lei
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import $ from'jquery'
import RequestComponent from "./RequestComponent";
import {permissionCheck}  from '../utils'
import {getInfoFromLocalStorage, removeInfoFromLocalStorage, setInfoToLocalStorage} from "../actions";
import lockFactory from "./lock/lockFactory";
import request from "./request";
const sysConfigKeyParams = "key";

//ssss/sss/sss/:key
//ssss/sss/sss/rwgl

const stringParser = (str, value) =>{
    if(typeof str !== "string"){
        return str;
    }
    if(value && /\${.*}$/.test(str)){
        let expression = str.replace(/\${(.*)}$/,"$1");
        try{
            let fieldValue = extractAttrValue(expression, value);
            return stringParser(fieldValue, value);
        }catch (e) {
            return str;
        }
    }
    return str;
};

export const attrParser = (attrValue, json)=>{
    let objs = [];
    attrValue = attrValue.replace(/\${[^}]*}/g, (expression)=>{
        let parserValue = stringParser(expression, json);
        if(typeof parserValue === "object"){
            objs.push(parserValue);
        }else if(typeof parserValue === "function"){
            objs.push(parserValue);
        }
        return parserValue;
    });
    if(objs.length > 0){
        if(objs.length === 1){
            return objs[0]
        }
        return objs;
    }
    if(attrValue.indexOf("+") === -1){
        return attrValue;
    }else{//存在表达式
        let result = "";
        let expressions = attrValue.split("+");
        for(let i = 0 ; i < expressions.length; i++){
            let expression = expressions[i];
            if(!/^\d+$/.test(expression)){//如果不是一个数字
                result += `'${expression}'+`;
            }else{
                result += expression+"+";
            }
        }
        try {
            return eval(result.replace(/([^\+]*)\+$/,"$1"));
        }catch (e) {
            return attrValue;
        }
    }
};

export const contentParser = (parserJson, originalJson)=>{
    if(typeof parserJson !== "object"){
        return parserJson;
    }
    for(let attr in parserJson){
        let value = parserJson[attr];
        if(typeof value === "string"){
            parserJson[attr] = attrParser(value, originalJson);
        }else{
            contentParser(value, originalJson);
        }
    }
};
export const extractAttrValue = (field, json)=>{
    let firstAttr = field.replace(/([^\.]*)\..*/,"$1");
    if(firstAttr === field || firstAttr === `${field}.`){
        return json[firstAttr];
    }
    let otherAttr = field.replace(/[^\.]*\.(.*)/,"$1");
    return extractAttrValue(otherAttr, json[firstAttr]);
};

export default class BaseComponent extends RequestComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.sysConfig = {};
        this.sysConfigKeyParamsVal='';
        this.getSysConfigValue(this.props,value=>{
            contentParser(value, value);
            contentParser(value, window);
            this.sysConfig = value;
            this.sysConfigLoadOver();
            this.setState({});
        });
        let params = this.getParentParams();
        this.urlParams = params;
        this.permissionCheck=permissionCheck;
        this.listenerList = {};
        window.sysConfigGetValueByKey = this.sysConfigGetValueByKey;
        this.themeBgColor = window.sysConfig && window.sysConfig.getValueByKey("NewMenuBg", '#0050B3')||'#0050B3';
        window.themeBgColor=this.themeBgColor;
        //解决偶发模块没有 window.currentUser
        if(!window.currentUser){
            window.currentUser=getInfoFromLocalStorage("currentUser")
        }
        this.getInfoFromLocalStorage = getInfoFromLocalStorage;
        this.lockFactory = lockFactory;
        //获取模块权限
        this.checkModuleAuth=bindModuleAuth;
        let projectTitle = window && window.sysConfigGetValueByKey && window.sysConfigGetValueByKey("contribute.project.title");
        if (projectTitle) {
            $("#index_title").text(projectTitle);
        }
    }

    getParentParams(){
        let search = window.location.search;
        if(search){
            let uuid = search.replace(/.*paramsUUID=([A-Za-z0-9\-_]+).*/, "$1");
            if(uuid){
                let params = getInfoFromLocalStorage("paramsUUID_" + uuid);
                return params;
            }
        }
        return null;
    }

    setParentParams(value){
        let search = window.location.search;
        if(search){
            let uuid = search.replace(/.*paramsUUID=([A-Za-z0-9\-_]+).*/, "$1");
            if(uuid){
                let params = setInfoToLocalStorage("paramsUUID_" + uuid,value);
                return params;
            }
        }
        return null;
    }


    removeParentParams(){
        let search = window.location.search;
        if(search){
            let uuid = search.replace(/.*paramsUUID=([A-Za-z0-9\-_]+).*/, "$1");
            if(uuid){
                removeInfoFromLocalStorage("paramsUUID_" + uuid);
                return true;
            }
        }
        return false;
    }

    //获取配置项
    sysConfigGetValueByKey(key, defaultValue = '') {
        return window.sysConfig && window.sysConfig.getValueByKey(key, defaultValue) || defaultValue
    }

    sysConfigLoadOver(){}

    getSysConfigKey(props) {
        if(!props){
            props = this.props;
        }
        let sysConfigKeyParamsVal= props.match&&props.match.params[sysConfigKeyParams]?props.match.params[sysConfigKeyParams]:this.sysConfigKeyParamsVal;
        sysConfigKeyParamsVal = sysConfigKeyParamsVal || props.sysConfigKeyParamsVal;
        this.sysConfigKeyParamsVal = sysConfigKeyParamsVal;
        return sysConfigKeyParamsVal;
    }

    refreshSysConfigValue(props) {
        this.getSysConfigValue(props, value=>{
            contentParser(value, value);
            contentParser(value, window);
            this.sysConfig = value;
            this.sysConfigLoadOver();
            this.setState({});
        });
    }

    getSysConfigValue(props, callback) {
        let key = this.getSysConfigKey(props);
        if(!key){
            return;
        }
        this.request({
            url: "/cm-sites-sys/config/getValueByConfigKey",
            body: {configKey: key},
            method: "post",
            callBack: (data)=>{
                callback(data);
            }
        })
    }

    complete(data){
        this.props.complete&&this.props.complete(data);
    }

    createPostMessage = (callBack, listener) => {
        if(listener) {
            this.listenerList[listener]=callBack;
            if (window.addEventListener) {
                console.log('----------------监听了postmessage事件from '+listener);
                window.removeEventListener('message', this.listenerList[listener], false);
                window.addEventListener('message', this.listenerList[listener], false);
            } else {
                if (window.attachEvent) {   // IE before version 9
                    window.attachEvent("message", this.listenerList[listener]);
                }
            }
        }
    };

    destroyPostMessage = (listener) => {
        if(listener && this.listenerList[listener]) {
            if (window.removeEventListener) {
                console.log('----------------卸载了postmessage事件from '+listener);
                window.removeEventListener('message', this.listenerList[listener], false);
            } else {
                if (window.detachEvent) {   // IE before version 9
                    window.detachEvent("message", this.listenerList[listener]);
                }
            }
        }
    };

    callPostMessage = (message) => {
        // 通过 targetOrigin 属性来指定哪些窗口能接收到消息事件，
        // 其值可以是字符串“*”（表示无限制）或者一个 URI（如果要指定和当前窗口同源的话可设置为"/"）。
        // 在发送消息的时候，如果目标窗口的协议、主机地址或端口号这三者的任意一项不匹配 targetOrigin 提供的值，那么消息就不会发送。
        if(window.opener) {
            window.opener.postMessage(JSON.stringify(message), "*");
        }
    };

    // 获取当前人媒体列表
    getCurrentMediaList = () => {
        return new Promise(((resolve, reject) => {
            this.request({
                url: "/cm-sites-pms/media/getCurrentUserMediaGroupByType",
                callBack: (res) => {
                    resolve(res)
                }
            })
        }))
    };


    /**
     * 仅支持纵屏。
     * returns the font size after adaptation according to the screen density.
     * 返回根据屏幕宽适配后字体尺寸
     * fontSize 字体尺寸
     * systemScale 是否计算比例因子
     * textScaleFactor  比例因子，一般用来计算字体大小
     */
    textScaleFactor = 1.0;
    // 屏幕宽度
    _screenWidth = document.documentElement.clientWidth;
    _screenHeight = document.documentElement.clientHeight;
    // 设计图宽度
    _designW = 1920;
    getSp(fontSize, systemScale = false) {
        let size = (fontSize * this._screenWidth / this._designW);
        return systemScale == true ? size : size / this.textScaleFactor;
    }


    render() {
        return this.customRender?this.customRender():<div></div>;
    }

}


//获取模块权限
export const bindModuleAuth=({code='',callBack=()=>{}})=>{
    let getBindModuleBusiness=getInfoFromLocalStorage('bindModuleAuth')||[];
    if(getBindModuleBusiness&&getBindModuleBusiness.length){
        checkBindAuth(code,getBindModuleBusiness,callBack)
    } else {
        callBack(false)
    }
};

export const checkBindAuth=(code,bindModuleBusiness,callBack)=>{
    if(code&&bindModuleBusiness&&bindModuleBusiness.indexOf(code)>-1){
        callBack(true)
    }else{
        callBack(false)
    }
};
export  const getModAuth=(call)=>{
    let params={
        deptId:window.currentUser&&window.currentUser.deptIds[0]||"",
    };
    request({
        url: "/cm-sites-sys/businessModule/getAllBusinessModulesAndBindCode",
        method:'post',
        body:params,
        callBack: (res) => {
            let bindModuleAuth=[];
            if(res&&res.moduleBusiness&&res.moduleBusiness.length){
                let moduleBusiness=res.moduleBusiness;
                moduleBusiness.forEach(item=>{
                    if(item.bindServiceNames){
                        bindModuleAuth=bindModuleAuth.concat(item.bindServiceNames)
                    }
                });
            }
            setInfoToLocalStorage("bindModuleAuth", bindModuleAuth);
            call&&call();
        }
    })
}

